const {h, render, Component} = require('preact');
const FaqsView = require('../../views/faq/faqs')
const Helper = require('../../../helper')

class Faqs extends Component {
  constructor(props) {
    super(props);
    this.setState({configFromDom: Groupon.Utils.getConfigFromDom()});
    this.getUrlForFAQ = this.getUrlForFAQ.bind(this);
  }

  componentDidMount() {
    let inbentaSessionToken = sessionStorage.getItem('inbentaSessionKey')
    if (inbentaSessionToken === null || inbentaSessionToken === undefined) {
      Helper.createSession();
    }
  }

  getUrlForFAQ(categoryId){
    return `${this.state.configFromDom.FAQBASEURL}#faqs:category-${categoryId}?crumbs=${btoa(JSON.stringify([{"text":"Customer Support","url":"/customer_support"}]))}`
  }

  render(){
    let configFromDom = this.state.configFromDom;
    if(configFromDom.FAQBASEURL && configFromDom.landingPageFAQs && configFromDom.landingPageFAQs.length >= 3){
      return (
        <FaqsView
          faqBaseURL = {`${configFromDom.FAQBASEURL}`}
          landingPageFAQs = {configFromDom.landingPageFAQs}
          getUrlForFAQ = {this.getUrlForFAQ.bind(this)}
        />
      );
    }
    return null;
  }
}

module.exports = Faqs
